import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleFieldConfig } from '../../simple-field.interface';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-input-lead',
  templateUrl: './input-lead.component.html',
  styleUrls: ['./input-lead.component.scss']
})
export class InputLeadComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  field: SimpleFieldConfig;
  group: UntypedFormGroup;
  display: boolean=false;
  formType: any;
  ngOnInit() {

    console.log(this.formType);
    

    if(this.group!=undefined){
      this.display=true;
    }
  }
    
  get validInputType(): string {
    const supportedTypes = [
      'color', 'date', 'datetime-local', 'email', 'month', 'number',
      'password', 'search', 'tel', 'text', 'time', 'url', 'week'
    ];
    const type = (this.field?.inputType || 'text').toLowerCase();
    return supportedTypes.includes(type) ? type : 'text';
  }

  hasError(validation: any): boolean {
    if (!this.field?.name || !this.group?.get(this.field.name)) return false;
    const control = this.group.get(this.field.name);
    if (!control.errors) return false;
    const name = (validation?.name || '').toLowerCase().trim();
    if (name === 'required') {
      return control.hasError('required') || control.hasError('requiredTrue');
    }
    if (name === 'minlength') {
      return control.hasError('minlength');
    }
    if (name === 'maxlength') {
      return control.hasError('maxlength');
    }
    if (name === 'pattern') {
      return control.hasError('pattern');
    }
    return control.hasError(validation?.name) || control.hasError(name);
  }

  getErrorMessage(validation: any): string {
    if (validation?.message && validation.message.trim() !== '') {
      return validation.message;
    }
    const name = (validation?.name || '').toLowerCase().trim();
    const label = this.field?.label || 'This field';
    if (name === 'required') {
      return `${label} is required.`;
    }
    if (name === 'minlength') {
      const min = validation?.minLength ?? validation?.min_length ?? validation?.validator ?? '';
      return `${label} must be at least ${min} characters long.`;
    }
    if (name === 'maxlength') {
      const max = validation?.maxLength ?? validation?.max_length ?? validation?.validator ?? '';
      return `${label} cannot exceed ${max} characters.`;
    }
    if (name === 'pattern') {
      return `Invalid format for ${label}.`;
    }
    return `${label} is invalid.`;
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    constructor(private router: Router) {
        this.url = this.router.url || '';
            this.router.events
              .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
              .subscribe(() => { this.url = this.router.url || ''; });
    }
}

